import { useNotifyAboutSettingsChanged } from './useNotifyAboutSettingsChanged';

export const SupportExternalInfinity = () => {
  useNotifyAboutSettingsChanged();

  return null;
};
